const maskCPFandCNPJ = (texto) => {
  if(!texto) {
    return texto;
  }

  texto= texto.replace(/(\.|\/|-)/g,"");

  if(texto.length === 13 || texto.length === 10) {
    texto = '0' + texto;
  }

  if (texto.length <= 11) {
      return texto.replace(/(\[a-zA-Z0-9]{3})(\[a-zA-Z0-9]{3})(\[a-zA-Z0-9]{3})(\[a-zA-Z0-9]{2})/g, '$1.$2.$3-$4');
  } else {
      return (texto.replace(/([a-zA-Z0-9]{2})([a-zA-Z0-9]{3})([a-zA-Z0-9]{3})([a-zA-Z0-9]{4})([a-zA-Z0-9]{2})/g,"$1.$2.$3/$4-$5"));
  }
}

export default maskCPFandCNPJ;
